




































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  IWorkOrderCard,
  ITransferStatusList,
  TRANSFER_STATUS_LIST,
  IStaff,
  TransferStatus,
  Callback,
  IWhoAmI,
} from "@/interfaces";
import { Getter, Action } from "vuex-class";
import { TransferWorOrder } from "@/api";
import { STATUS_RULES, TO_RULES, MEMO_RULES, USER_RULES } from "@/validators";

@Component({})
export default class RimRepairTransferComponent extends Vue {
  @Prop({ required: true }) workOrder!: IWorkOrderCard;

  @Prop({ required: true }) type!: string;

  @Getter("technician", { namespace: "AppModule" })
  public technician!: IStaff[];

  @Getter("salesMan", { namespace: "AppModule" })
  public salesMan!: IStaff[];

  @Getter("shopMan", { namespace: "AppModule" })
  public shopMan!: IStaff[];

  @Action("setSnackbar", { namespace: "AppModule" })
  public setSnackbarAction!: Callback;

  @Getter("user", { namespace: "AppModule" })
  public myself!: IWhoAmI | null;

  public memo = "";
  public status: TransferStatus | null = null;
  public to: number = null;
  public user: number | null = null;
  public buttonLoading = false;
  public statusRules = STATUS_RULES;
  public toRules = TO_RULES;
  public userRules = USER_RULES;
  public memoRules = MEMO_RULES;
  public valid = false;

  get list(): ITransferStatusList[] {
    return TRANSFER_STATUS_LIST.filter((s) =>
      this.type === "technician" ? [7, 13].includes(s.value) : s
    );
  }

  get toList() {
    let list: any[] = [];
    if (this.type === "technician") {
      list = [{ N: "Shop manager", V: 0 }];
    } else if (this.type === "office") {
      list = [{ N: "Shop manager", V: 0 }];
    } else if (this.type === "shop-manager") {
			/* WE ADD SHOP MANAGER HERE, WITH VALUE OF 3, 
			UNLIKE THE SHOP MANAGER ABOVE WITH VALUE OF 0,
			BECAUSE 3 MEANS THAT IT WILL SHOW ONLY ITSELF 
			AS AN OPTION UNDER SHOP MANAGER (A SHOPMAN CAN'T ASSIGN
			TO ANY SHOPMAN OTHER THAN HIMSELF)
			 */
      list = [
        { N: "Technician", V: 1 },
        { N: "Office", V: 2 },
        { N: "Shop manager", V: 3 },
      ];
    }
    return list;
  }

  get usersList() {
    let list: IStaff[] = [];

    if (this.to!=null && this.to != undefined) {
      if (this.to == 1) {
        list = this.technician;
      } else if (this.to == 0) {
        list = this.shopMan;
      } else if (this.to == 3) {
        // IN THIS CASE WE WANT THE SHOP-MANAGER LIST BUT ONLY
        // WITH THE CURRENT SHOP MANAGER, SO THIS USER CAN'T
        // TRANSFER TO OTHER SHOP MANAGERS, OTHER THAN HIMSELF.
        list = this.shopMan.filter((m) => m.RecordID == this.myself.UserID);
      } else if (this.to == 2) {
        list = this.salesMan;
      }
    }
    return list;
  }

  resetUser() {
    this.user = null;
  }

  close() {
    this.$emit("close");
  }

  async validate() {
    try {
      if ((this.$refs.transferForm as HTMLFormElement).validate()) {
        this.buttonLoading = true;
        const resp = await TransferWorOrder({
          TargetUserID: this.user!,
          Status: this.status!,
          WorkOrderID: this.workOrder.RecordID,
          Memo: this.memo,
        });
        this.buttonLoading = false;
        if (resp.Ok) {
          this.setSnackbarAction({
            message: `Work order transferred successfully`,
            status: "success",
          });
          this.$emit("close-succes");
        }
      }
    } catch (err) {
      //
    }
  }
}
